module.exports = __webpack_public_path__ + "static/media/ice-cream-2.f1952e82.png";